import type { ItemProps } from '@tryhackme/thm-ui-components/dist/components/atoms/desktop-nav/desktop-nav.types';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { UserRoles } from 'src/common/enums';
import { useFeatureIsOn } from 'src/common/growthbook';
import { useHasRole } from 'src/common/hooks/use-user-has-role';
export const UseIsNavItemActive = (item: ItemProps) => {
  const location = useLocation();
  const isRoomMaker = useHasRole(UserRoles.ROOM_MAKER);
  const isNewNavEnabled = useFeatureIsOn('new-navigation');
  const activeSubItem = useMemo(() => item.subItems?.find(subItem => subItem.href === location.pathname), [item.subItems, location.pathname]);
  const isNavItemActive = useMemo(() => {
    const isUserInRoom = location.pathname.startsWith('/room/');
    const isLearnSection = item.name === 'Learn';
    const isManageRooms = location.pathname === '/rooms' && location.search.includes('tab=manage-rooms');
    const isSimPath = location.pathname.startsWith('/soc-sim') || location.pathname.startsWith('/threat-hunting-sim');
    const shouldHighlightSim = isSimPath && ((isNewNavEnabled ? item.name === 'Practice' : item.name === 'Learn') || Boolean(activeSubItem));
    if (isUserInRoom && !isLearnSection) return Boolean(activeSubItem);
    if (isUserInRoom) return isLearnSection;
    if (location.pathname === '/paths' && item.name === 'Learn' || location.pathname === '/your-material/custom-development' && item.name === 'Develop' || location.pathname === '/your-material/content-engineers' && item.name === 'Develop' || location.pathname === '/develop-rooms' && item.name === 'Develop' || isManageRooms && item.name === 'Develop' || shouldHighlightSim) {
      return true;
    }
    if (item.name === 'Other' && isRoomMaker) return false;
    return Boolean(activeSubItem);
  }, [activeSubItem, item.name, location.pathname, location.search, isRoomMaker, isNewNavEnabled]);
  return isNavItemActive;
};